import { isPointInStatePolygon } from "~/util/state-polygon";
import Scene from "~/scene";
import { store } from "~/state/store";
import { watch, watchCoordinates } from "~/state/util";
import { node } from "~/util/dom";

const HIDE_CLASS = "hide";

function projectPoint(mercX: number, mercY: number) {
	const pixX = (mercX - 1300000) / 3600;
	const pixY = (6724000 - mercY) / 3600;

	return {
		x: pixX,
		y: pixY,
	};
}

export default class MiniCzechMap {
	#container: HTMLDivElement;

	#point: HTMLSpanElement;

	#url: string;

	constructor() {
		this.#url = `/img/mini-czech-map.png`;

		this.#build();

		const mapState = store.getState().map;

		this.#update(mapState.longitude, mapState.latitude);

		const wt = watch(store.getState, "map", watchCoordinates);

		store.subscribe(wt((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this.#update(newMap.longitude, newMap.latitude);
			}
		}));
	}

	get container() {
		return this.#container;
	}

	#build() {
		const container = node("div", { className: "control-mini-czech-map print" });
		const map = node("img", { src: this.#url });
		const point = node("span", { className: "czech-point" });

		container.append(map, point);

		this.#point = point;
		this.#container = container;
	}

	async #update(wgsX: number, wgsY: number) {
		const stateCheck = await isPointInStatePolygon(wgsX, wgsY, {
			cs: true,
		});

		if (!stateCheck) {
			this.#point.classList.add(HIDE_CLASS);

			return;
		}

		this.#point.classList.remove(HIDE_CLASS);

		const merc = Scene.coordsFromWGS84(wgsX, wgsY).toMercator();
		const point = projectPoint(merc[0], merc[1]);

		this.#point.style.left = `${point.x}px`;
		this.#point.style.top = `${point.y}px`;
	}
}
